module.exports = __webpack_public_path__ + "static/media/gg_zoom_finger.ef113d06.gif";